import React from 'react';
import { Link } from 'react-router-dom';
import { FaHandshake, FaBuilding, FaBoxOpen, FaSeedling, FaMoneyBillWave, FaCalculator, FaFolderOpen, FaRegFileAlt, FaExchangeAlt, FaWater, FaCreditCard, FaFileSignature, FaChartLine, FaIndustry, FaBriefcase, FaUserTie } from 'react-icons/fa';

const mastersItems = [
  { name: 'Purchase Broker', icon: <FaHandshake />, path: '/purchase-broker' },
  { name: 'Sale Broker', icon: <FaBriefcase />, path: '/broker' },
  { name: 'CHA', icon: <FaBuilding />, path: '/cha' },
  { name: 'CMA', icon: <FaBoxOpen />, path: '/cma' },
  { name: 'Commodity', icon: <FaSeedling />, path: '/commodity' },
  { name: 'Cost Breakup', icon: <FaMoneyBillWave />, path: '/cost-breakup' },
  { name: 'Cost Component', icon: <FaCalculator />, path: '/cost-component' },
  { name: 'Document', icon: <FaFolderOpen />, path: '/document' },
  { name: 'Document Type', icon: <FaRegFileAlt />, path: '/document-type' },
  { name: 'FX Rate', icon: <FaExchangeAlt />, path: '/fx-rate' },
  { name: 'High Seas Agreement', icon: <FaWater />, path: '/high-seas-agreement' },
  { name: 'Issuing Authorities', icon: <FaUserTie />, path: '/issuing-authorities' },
  { name: 'Payment', icon: <FaCreditCard />, path: '/payment' },
  { name: 'Received Payment', icon: <FaMoneyBillWave />, path: '/received-payment' },
  { name: 'Purchase Contract', icon: <FaFileSignature />, path: '/purchase-contract' },
  { name: 'Sales Channel', icon: <FaChartLine />, path: '/sales-channel' },
  { name: 'Supplier', icon: <FaIndustry />, path: '/supplier' },
];

const MastersOverview = () => {
  return (
    <div className=" py-10 px-4">
      <div className="mb-12">
        <h2 className="text-3xl font-extrabold text-sky-700 mb-1 text-left">Masters</h2>
        <p className="text-base text-gray-500 font-medium text-left">Manage all your master data modules from one place</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {mastersItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className="flex flex-row items-center h-20 px-5 bg-white rounded-md shadow border border-gray-200 hover:bg-sky-50 transition-colors duration-150 group cursor-pointer min-w-0"
          >
            <span className="text-2xl text-sky-600 group-hover:text-sky-800 mr-4 flex-shrink-0">{item.icon}</span>
            <span className="text-lg font-semibold text-gray-700 group-hover:text-sky-800 text-left truncate">{item.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MastersOverview; 